import { render } from "./Breadcrumbs.vue?vue&type=template&id=b2058268"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Breadcrumbs.vue"]])

export default __exports__